module.exports = __webpack_public_path__ + "img/home2.3499bc3a.JPG";